import {deparam, param} from 'nutshell-core/routing/query-parameters';

import type {VersionParam} from '../../reports/report-types';

export const updateSearchWithNewFilterAndVersion = (
    filterKey: string,
    editionId: string,
    comparisonEditionId: string,
    search: string,
    version: VersionParam
) => {
    // if the passed filterKey is not valid, return the search string
    if (
        // this is the shared EDITION_FILTER_KEYS array from email-marketing/utils,
        // but it breaks jest to import it here
        ![
            'sentEditions',
            'clickedEditions',
            'viewedEditions',
            'bouncedEditions',
            'unsubscribedEditions',
        ].includes(filterKey)
    ) {
        return search;
    }

    let newSearch = search.slice(1);
    newSearch = deparam(search);
    // @ts-expect-error
    const searchFilter = newSearch.filter;
    const filterKeysInSearch = Object.keys(searchFilter);
    filterKeysInSearch
        .filter((key) => key !== 'period')
        .forEach((key) => {
            delete searchFilter[key];
        });

    if (version === 'b') {
        searchFilter[filterKey] = [comparisonEditionId];
    } else {
        // If we're filtering for both versions, the &version=both param will grab both versions
        searchFilter[filterKey] = [editionId];
    }

    // @ts-expect-error
    newSearch.filter = searchFilter;
    // @ts-expect-error
    newSearch.version = version;
    newSearch = param(newSearch);

    return newSearch;
};
